import { Injectable, NgZone, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { WINDOW } from "@tylertech/shared-module";
import { Observable, debounceTime, fromEvent } from "rxjs";

@Injectable()
export class TruncateTextService
{
    onResize: Observable<Event>;

    constructor()
    {
        const ngZone = inject(NgZone);
        const window = inject<globalThis.Window>(WINDOW);

        this.onResize = ngZone.runOutsideAngular(() =>
            fromEvent(window, "resize")
                .pipe(
                    debounceTime(500),
                    takeUntilDestroyed())
        );
    }
}
